import "./Hero.css";
import heroImage from "../assets/hero.png";


function Hero() {
  return (
    <section
      className="hero"
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      <div className="overlay">
        <h2>Turning Corporate Responsibility<br/> into Lasting Social Impact</h2>

<p>We work at the grassroots level to uplift communities through <br/>education,
  environment, and livelihood initiatives.</p>
      </div>

{/*Who We Are*/}

    </section>

  );

}


export default Hero;